import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const VoidInvoiceMutation = graphql.persisted(
  "VoidInvoice",
  graphql(`
    mutation VoidInvoice($input: VoidInvoiceInput!) {
      voidInvoice(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export { VoidInvoiceMutation };

export function useVoidInvoice() {
  return useMutation(VoidInvoiceMutation);
}
